import type { ReactNode } from "react";
import { Link } from "react-router";

import { ChevronRightIcon } from "@prequel/shared-components";

type OverviewCardProps = {
  title: ReactNode;
  to: string;
  linkLabel: string;
  headerAction?: ReactNode;
  children: ReactNode;
};

const OverviewCard = ({ title, to, linkLabel, headerAction, children }: OverviewCardProps) => (
  <section className="rounded-md border border-stone-200 bg-white">
    <div className="flex items-center justify-between gap-4 border-b border-stone-100 p-4">
      <h3 className="text-sm font-medium text-stone-800">{title}</h3>
      <div className="flex items-center gap-3">
        {headerAction}
        <Link
          to={to}
          aria-label={linkLabel}
          className="
            text-stone-400
            hover:text-stone-600
          "
        >
          <ChevronRightIcon className="size-4" />
        </Link>
      </div>
    </div>
    <div className="divide-y divide-stone-100 px-4">{children}</div>
  </section>
);

export const OverviewCardRow = ({
  name,
  providerName,
  value,
}: {
  name: string;
  providerName: string;
  value: ReactNode;
}) => (
  <div className="grid grid-cols-[2fr_2fr_1fr] items-center gap-4 py-3 text-sm">
    <span className="min-w-0 truncate text-stone-800">{name}</span>
    <span className="min-w-0 truncate text-stone-500">{providerName}</span>
    <span className="truncate text-right font-mono text-xs text-stone-600">{value}</span>
  </div>
);

export const OverviewCardEmpty = ({ message }: { message: string }) => (
  <p className="py-6 text-center text-sm text-stone-500">{message}</p>
);

export default OverviewCard;
